import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

export type FilterSectionHeadingProps = {
  children: ReactNode;
  /**
   * Grise l'intitulé d'une section momentanément inopérante (aucune option à
   * proposer, dépendance non choisie) : la section reste visible — sa
   * disparition ferait sauter la colonne — mais annonce qu'elle n'attend rien.
   */
  muted?: boolean;
};

/**
 * Intitulé d'une section de la colonne de filtres.
 *
 * `subtitle2` en 600 : assez de poids pour découper la colonne, pas assez pour
 * concurrencer le titre de la page. Cinq copies inline appliquaient déjà ce
 * couple exact.
 */
export function FilterSectionHeading({
  children,
  muted = false,
}: FilterSectionHeadingProps) {
  return (
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 600,
        color: muted ? "text.disabled" : "text.primary",
      }}
    >
      {children}
    </Typography>
  );
}
